<template>

    <section v-if="quoteRequest && quoteRequest.company">
        <div class="container">
            <br><br>
            <h2 class="title is-title is-4 has-text-centered">Your Quote is Submitted</h2>
        </div>
    </section>

</template>

<script>

export default {
  name: 'section-submitted',
  props: ['dateDeadline', 'quoteRequest', 'dateSubmitted', 'reopenVisible', 'step', 'stepReached', 'reopening'],
  data () {
    return {}
  },
  methods: {
  },
  computed: {}
}
</script>
